import React, { useState, useEffect, useRef, forwardRef } from 'react';
import { useDispatch, useSelector } from "react-redux";
import { Row, Col } from 'react-bootstrap';
import styles from './Collabs.module.css';
import { Dialog as PrimeDialog } from 'primereact/dialog';
import Langs from "../../app/lang/langs";
import { checkIfPublicHoliday, getFormattedDate, isAdmin, isOwner } from '../../app/utils/helpers';
import { DataTable } from 'primereact/datatable';
import { Column } from 'primereact/column';
import moment from 'moment';
import { setCollabReport, updateCollabReport } from '../../containers/reports/reportsSlice';
import { InputWithSubmit } from '../inputs/InputWithSubmit';
import { insertPrimeCollab } from '../../containers/planning/planningSlice';
import { Button } from 'primereact/button';
import logoVitalGrp from "../../assets/images/logo-VITAL_GRP.png";
import logoVitalInf from "../../assets/images/logo-VITAL_INF.png";
import logoVitalIt from "../../assets/images/logo-VITAL_IT.png";
import logoVitalIng from "../../assets/images/logo-VITAL_ING.png";

import { generateCraPdf } from './collabsSlice';

// MUI imports for mobile
import Dialog from '@mui/material/Dialog';
import DialogContent from '@mui/material/DialogContent';
import AppBar from '@mui/material/AppBar';
import Toolbar from '@mui/material/Toolbar';
import IconButton from '@mui/material/IconButton';
import Typography from '@mui/material/Typography';
import Slide from '@mui/material/Slide';
import Box from '@mui/material/Box';
import List from '@mui/material/List';
import ListItem from '@mui/material/ListItem';
import ListItemText from '@mui/material/ListItemText';
import Divider from '@mui/material/Divider';
import Chip from '@mui/material/Chip';
import MuiButton from '@mui/material/Button';
import CloseIcon from '@mui/icons-material/Close';
import FullscreenIcon from '@mui/icons-material/Fullscreen';
import FullscreenExitIcon from '@mui/icons-material/FullscreenExit';
import PictureAsPdfIcon from '@mui/icons-material/PictureAsPdf';

const logos = {
    "VITAL_GRP": logoVitalGrp,
    "VITAL_GRP_2": logoVitalGrp,
    "VITAL_ING": logoVitalIng,
    "VITAL_INF": logoVitalInf,
    "VITAL_IT": logoVitalIt
}

const SlideUpTransition = forwardRef(function SlideUpTransition(props, ref) {
    return <Slide direction="up" ref={ref} {...props} />;
});

export function CollabModal(props) {

    const dispatch = useDispatch()

    const teams = useSelector((state) => state.teams)
    const settings = useSelector((state) => state.settings)
    const collabReport = useSelector((state) => state.reports.collabReport)
    const selectedDate = useSelector((state) => state.planning.selectedDate)
    const userRoleId = useSelector((state) => state.login.userRoleId)
    const isMobile = useSelector((state) => state.settings.isMobile)
    const selectedFormData = useSelector((state) => state.planning.selectedFormData)
    const [maximized, setMaximized] = useState(false)
    const mounted = useRef(null)


    useEffect(() => {
        if (!mounted.current) {
            mounted.current = true
        }
    })

    useEffect(() => {

    }, [collabReport])

    const handleMaximize = (e, dialog) => {
        setMaximized(e.maximized)
    }

    function onHide() {
        setMaximized(false)
        if (props.onHide) props.onHide()
        dispatch(setCollabReport(null))
    }

    function handleImpressCra(selectedType) {
        const monthDate = moment(selectedDate, "x").format("MM-YYYY");
        const fileName = `CRA_${monthDate}.pdf`
        let type = "COMPTA"
        if (selectedType) type = selectedType
        // Appel de l'action pour générer le pdf avec selectedFormData et CollabReport
        dispatch(generateCraPdf({
            id_collab: selectedFormData.id,
            id_team: selectedFormData.id_team,
            monthDate: monthDate,
            selectedDate: selectedDate,
            fileName: fileName,
            type: type
        }))
    }

    function generateCollabData() {
        let data = []
        let startDate = moment(selectedDate, "x").startOf("month")
        let endDate = moment(selectedDate, "x").endOf("month")
        while (endDate.isAfter(startDate)) {
            let rowData = {
                dateTime: startDate.format("x"),
                day: startDate.format("dddd"),
                date: startDate.format("D-MMM"),
                planning: "",
                vacation: "",
                intervention: "",
                description: "",
                astreinte: "",
                text: ""
            }
            if (collabReport && collabReport.planning) {
                let planningData = collabReport.planning[startDate.format("DD-MM-YYYY")]
                if (planningData) {
                    rowData.planning = planningData.type
                    rowData.vacation = planningData.vacation || ""
                    rowData.intervention = planningData.intervention || ""
                    rowData.astreinte = planningData.astreinte
                    rowData.color = planningData.color || ""
                    rowData.description = planningData.description || ""
                    rowData.text = planningData.text || ""
                }
            }
            data.push(rowData)
            startDate.add(1, "day")
        }
        return data
    }


    let collabData = generateCollabData()

    const rowClass = (data) => {
        let className = {}
        let date = moment(data.dateTime, "x")

        let weekDay = date.day()
        if (weekDay == 0) className = {
            'bg-sunday': true
        }
        else if (weekDay == 6) className = {
            'bg-saturday': true
        }
        else {
            className = {
                'bg-holiday': checkIfPublicHoliday(settings.holidays[date.year()], date, getIdCountryFromTeamId(selectedFormData.id_team))
            }
        }
        return className
    }

    function getIdCountryFromTeamId(teamId) {
        let idCountry = 1
        if (teamId) {
            let teamsFiltered = teams.list && teams.list.filter(t => t.id == teamId)
            if (teamsFiltered && teamsFiltered[0]) {
                idCountry = teamsFiltered[0].id_country
            }
        }
        return idCountry
    }

    const astreinteCellStyle = (data) => {
        if (data.color) {
            return <Col style={{ backgroundColor: data.color, color: "white", textAlign: 'center', fontSize: '14px' }}>
                <Langs str={data.text || "-"} />
            </Col>
        }
    }

    const handlePrimeSubmit = (event) => {

        let value = Number(event.target.value)
        let month = moment(selectedDate).format("MM-YYYY")
        if (typeof value != 'number' || !month) return

        let primeParams = {
            id_collab: selectedFormData.id,
            type: event.target.id,
            value: value,
            month: month
        }

        dispatch(insertPrimeCollab(primeParams))
        let primes = Object.assign({}, collabReport.primes)
        primes[event.target.id] = value
        dispatch(updateCollabReport({
            key: "primes",
            value: primes
        }))
    }

    function getMaximizedView() {
        return <div><Row className='d-flex justify-content-center align-items-top g-4 px-3 py-3' id='CRA'>
            <Col xxl={7} style={{ minWidth: 0, padding: "5px" }}>
                <div style={{ border: '1px solid #d6d9de', borderRadius: '10px', overflow: 'hidden', boxShadow: '0 1px 4px rgba(0, 0, 0, 0.06)' }}>
                    <DataTable id="collab-table-1" value={collabData} size={"small"} showGridlines rowClassName={rowClass}>
                        <Column header="Jour" field="day" style={{ minWidth: '5rem', padding: '7px 10px', overflow: 'hidden' }}></Column>
                        <Column header="Date" field="date" style={{ minWidth: '5rem', padding: '7px 10px', overflow: 'hidden' }}></Column>
                        <Column header="Vacation" field="vacation" style={{ minWidth: '5rem', padding: '7px 10px', overflow: 'hidden' }}></Column>
                        <Column header="Intervention" field="intervention" style={{ minWidth: '6rem', padding: '7px 10px', overflow: 'hidden' }}></Column>
                        <Column header="Commentaires" field="description" style={{ minWidth: '9rem', maxWidth: '12rem', padding: '7px 10px', overflow: 'hidden' }}></Column>
                        <Column header="Astreinte" body={astreinteCellStyle} style={{ minWidth: '5rem', backgroundColor: "var(--orange-100)", padding: "0 0", overflow: 'hidden' }}></Column>
                    </DataTable>
                </div>
            </Col>
            <Col xxl={5} style={{ minWidth: 0, padding: "5px" }}>
                <Row className='d-flex justify-content-center align-items-center p-0 m-0'>
                    <table className={styles.ctable} id="collab-table-2" style={{ width: '100%' }}>
                        <thead>
                            <tr>
                                <th><Langs str='NAME' /></th>
                                <td colSpan="3">
                                    {selectedFormData.label}
                                </td>
                            </tr>
                            <tr>
                                <th><Langs str='COMPANY' /></th>
                                <td colSpan="3">
                                    {selectedFormData.company}
                                </td>
                            </tr>
                            <tr>
                                <th><Langs str='MATRICULE' /></th>
                                <td colSpan="3">
                                    {selectedFormData.matricule}
                                </td>
                            </tr>
                            {selectedFormData.ancienneteeDate ? <tr>
                                <th><Langs str='DATE_ANCIENNETE' /></th>
                                <td colSpan="3">
                                    {getFormattedDate(selectedFormData.ancienneteeDate)}
                                </td>
                            </tr>
                                :
                                selectedFormData.entryDate && <tr>
                                    <th><Langs str='ENTRY_DATE' /></th>
                                    <td colSpan="3">
                                        {getFormattedDate(selectedFormData.entryDate)}
                                    </td>
                                </tr>}
                            {selectedFormData.exitDate && <tr>
                                <th><Langs str='EXIT_DATE' /></th>
                                <td colSpan="3" className='text-danger'>
                                    {getFormattedDate(selectedFormData.exitDate)}
                                </td>
                            </tr>}
                            <tr>
                                <th><Langs str='CLIENT' /></th>
                                <td colSpan="3">
                                    {collabReport.clientTeamName}
                                </td>
                            </tr>
                            <tr className={styles.tableSeperator} />
                        </thead>
                        <tbody>
                            <tr>
                                <th colSpan={4}>
                                    <Langs str='RECAPITULATIF DES HEURES' />
                                </th>
                            </tr>
                            <tr>
                                <th><Langs str='Normales' /></th>
                                <td>
                                    {collabReport && collabReport.normal}
                                </td>
                                <td>
                                    {collabReport && collabReport.normal}
                                </td>
                                <th rowSpan="7" colSpan={1}>
                                    {collabReport && collabReport.total}
                                </th>
                            </tr>
                            <tr>
                                <th><Langs str='Nuit' /></th>
                                <td>
                                    {collabReport && collabReport.nuit}
                                </td>
                                <td>
                                    {collabReport && collabReport.nuit_}
                                </td>
                            </tr>
                            <tr>
                                <th><Langs str='Samedi' /></th>
                                <td>
                                    {collabReport && collabReport.saturday}
                                </td>
                                <td>
                                    {collabReport && collabReport.saturday_}
                                </td>
                            </tr>
                            <tr>
                                <th><Langs str='Dimanche' /></th>
                                <td>
                                    {collabReport && collabReport.hs100}
                                </td>
                                <td>
                                    {collabReport && collabReport.hs100_}
                                </td>
                            </tr>
                            <tr>
                                <th><Langs str='Supp' /></th>
                                <td>
                                    {collabReport && collabReport.supp}
                                </td>
                                <td>
                                    {collabReport && collabReport.supp_}
                                </td>
                            </tr>
                            <tr>
                                <th><Langs str='Fériées 100%' /></th>
                                <td >
                                    {collabReport && collabReport.hs00}
                                </td>
                                <td>
                                    {collabReport && collabReport.hs00}
                                </td>
                            </tr>
                            <tr>
                                <th><Langs str='Fériées 200%' /></th>
                                <td>
                                    {collabReport && collabReport.hs200}
                                </td>
                                <td>
                                    {collabReport && collabReport.hs200_}
                                </td>
                            </tr>
                            <tr>
                                <th><Langs str='Repos' /></th>
                                <th colSpan={3}>{collabReport && collabReport.repos}</th>
                            </tr>
                            <tr>
                                <th><Langs str='Astreinte' /></th>
                                <th colSpan={3}>{collabReport && collabReport.astreinte_days}</th>
                            </tr>
                            <tr>
                                <th className={styles.primaryCell1}><Langs str='Prime Astreinte' /></th>
                                <td className={styles.primaryCell1} colSpan="3">
                                    <InputWithSubmit
                                        value={collabReport.primes['ASTREINTE'] || 0}
                                        type='Number'
                                        id='ASTREINTE'
                                        min={0}
                                        onSubmit={handlePrimeSubmit}
                                        disabled={!isOwner(userRoleId)} />
                                </td>
                            </tr>
                            <tr>
                                <th className={styles.primaryCell2}><Langs str='Prime Week-end' /></th>
                                <td className={styles.primaryCell2} colSpan="3">
                                    <InputWithSubmit
                                        value={collabReport.primes['WEEKEND'] || 0}
                                        type='Number'
                                        id='WEEKEND'
                                        min={0}
                                        onSubmit={handlePrimeSubmit}
                                        disabled={!isOwner(userRoleId)} />
                                </td>
                            </tr>
                            <tr>
                                <th className={styles.primaryCell3}><Langs str='Prime Mission' /></th>
                                <td className={styles.primaryCell3} colSpan="3">
                                    <InputWithSubmit
                                        value={collabReport.primes['MISSION'] || 0}
                                        type='Number'
                                        id='MISSION'
                                        min={0}
                                        onSubmit={handlePrimeSubmit}
                                        disabled={!isOwner(userRoleId)} />
                                </td>
                            </tr>
                            <tr>
                                <th className={styles.primaryCell1}><Langs str='Prime Qualité' /></th>
                                <td className={styles.primaryCell1} colSpan="3">
                                    <InputWithSubmit
                                        value={collabReport.primes['QUALITE'] || 0}
                                        type='Number'
                                        min={0}
                                        id='QUALITE'
                                        onSubmit={handlePrimeSubmit}
                                        disabled={!isOwner(userRoleId)} />
                                </td>
                            </tr>
                            <tr>
                                <th className={styles.primaryCell1}><Langs str='Prime Objectif' /></th>
                                <td className={styles.primaryCell1} colSpan="3">
                                    <InputWithSubmit
                                        value={collabReport.primes['OBJECTIF'] || 0}
                                        type='Number'
                                        min={0}
                                        id='OBJECTIF'
                                        onSubmit={handlePrimeSubmit}
                                        disabled={!isOwner(userRoleId)} />
                                </td>
                            </tr>
                            <tr>
                                <th className={styles.primaryCell2}><Langs str='Prime Quadri' /></th>
                                <td className={styles.primaryCell2} colSpan="3">
                                    <InputWithSubmit
                                        value={collabReport.primes['QUADRI'] || 0}
                                        type='Number'
                                        min={0}
                                        id='QUADRI'
                                        onSubmit={handlePrimeSubmit}
                                        disabled={!isOwner(userRoleId)} />
                                </td>
                            </tr>
                            <tr>
                                <th className={styles.primaryCell3}><Langs str='Prime Noel' /></th>
                                <td className={styles.primaryCell3} colSpan="3">
                                    <InputWithSubmit
                                        value={collabReport.primes['NOEL'] || 0}
                                        type='Number'
                                        min={0}
                                        id='NOEL'
                                        onSubmit={handlePrimeSubmit}
                                        disabled={!isOwner(userRoleId)} />
                                </td>
                            </tr>
                            <tr>
                                <th className={styles.primaryCell1}><Langs str='Frais Téléphonique' /></th>
                                <td className={styles.primaryCell1} colSpan="3">
                                    <InputWithSubmit
                                        value={collabReport.primes['FRAIS_TEL'] || 0}
                                        type='Number'
                                        id='FRAIS_TEL'
                                        min={0}
                                        onSubmit={handlePrimeSubmit}
                                        disabled={!isOwner(userRoleId)} />
                                </td>
                            </tr>
                            <tr>
                                <th colSpan="1" rowSpan="2"><Langs str='PAIE AVANT ABSENCES' /></th>
                                <th colSpan="1" rowSpan="1"><Langs str='Salaire Base' /></th>
                                <th colSpan="1" rowSpan="1"><Langs str='Taux horaire' /></th>
                                <th colSpan="1" rowSpan="1"><Langs str='Salaire Brut' /></th>
                            </tr>
                            <tr>
                                <td>0</td>
                                <td>0</td>
                                <td>0</td>
                            </tr>
                            <tr>
                                <th><Langs str='Maladie' /></th>
                                <td>{collabReport && collabReport.maladie}</td>
                                <th rowSpan={2} colSpan={2}></th>
                            </tr>
                            <tr>
                                <th><Langs str='Congés Payés' /></th>
                                <td>{collabReport && collabReport.cp}</td>
                            </tr>
                            <tr>
                                <th><Langs str='Maternity' /></th>
                                <td>{collabReport && collabReport.maternity}</td>
                                <td>0</td>
                                <td>0</td>
                            </tr>
                            <tr>
                                <th><Langs str='Absence' /></th>
                                <td>{collabReport && collabReport.ai}</td>
                                <td>0</td>
                                <td>0</td>
                            </tr>
                            <tr>
                                <th><Langs str='Congés ss Solde' /></th>
                                <td>{collabReport && collabReport.css}</td>
                                <td>0</td>
                                <td>0</td>
                            </tr>
                            <tr>
                                <th><Langs str='Heures de retard' /></th>
                                <td>{collabReport && collabReport.missing}</td>
                                <td>0</td>
                                <td>0</td>
                            </tr>
                            <tr>
                                <th rowSpan={2}>
                                    <Langs str='CALCUL PAIE' />
                                </th>
                                <th><Langs str='Salaire Base' /></th>
                                <th><Langs str='Taux horaire' /></th>
                                <th><Langs str='Salaire Brut' /></th>
                            </tr>
                            <tr>
                                <td>0</td>
                                <td>0</td>
                                <td>0</td>
                            </tr>
                            <tr className={styles.tableSeperator} />
                            <tr className='m-4'>
                                <th><Langs str='Nb Jours travaillés' /></th>
                                <td colSpan={3}>
                                    {collabReport && collabReport.presence}
                                </td>
                            </tr>
                            <tr>
                                <th colSpan={4}><Langs str='FRAIS' /></th>
                            </tr>
                            <tr>
                                <th><Langs str='Frais de Repas' /></th>
                                <td colSpan={3}>
                                    {collabReport && collabReport.repas}
                                </td>
                            </tr>
                            <tr>
                                <th><Langs str='Frais Transport' /></th>
                                <td colSpan={3}>
                                    {collabReport && collabReport.transport}
                                </td>
                            </tr>
                            <tr>
                                <th><Langs str='Forfait Déplacement' /></th>
                                <td colSpan={3}>
                                    {collabReport && collabReport.deplacement}
                                </td>
                            </tr>
                            <tr>
                                <th><Langs str='Télétravail' /></th>
                                <td colSpan={3}>
                                    {collabReport && collabReport.telework}
                                </td>
                            </tr>
                        </tbody>
                    </table>
                </Row>
                <div className="mt-3 d-flex flex-wrap justify-content-center gap-2">
                    <Button className="rounded" label={<Langs str="Générer CRA PDF" />}
                        icon="pi pi-file-pdf"
                        severity="warning"
                        onClick={() => handleImpressCra("CRA")} />
                    {isOwner(userRoleId) && <Button className="rounded" label={<Langs str="Générer Compta PDF" />}
                        icon="pi pi-file-pdf"
                        onClick={() => handleImpressCra()} />}
                </div>
            </Col >
        </Row>
        </div>
    }

    function getMinimizedView() {
        return <div>
            <Row className='d-flex justify-content-center align-items-center p-2'>
                <Col md={6}>
                    <strong><Langs str='FAMILY_NAME' /></strong>
                </Col>
                <Col md={6}>
                    <div>{selectedFormData.nom}</div>
                </Col>
            </Row>
            <Row className='d-flex justify-content-center align-items-center p-2'>
                <Col md={6}>
                    <strong><Langs str='NAME' /></strong>
                </Col>
                <Col md={6}>
                    <div>{selectedFormData.prenom}</div>
                </Col>
            </Row>
            <Row className='d-flex justify-content-center align-items-center p-2'>
                <Col md={6}>
                    <strong><Langs str='POSTE' /></strong>
                </Col>
                <Col md={6}>
                    <div>{selectedFormData.poste}</div>
                </Col>
            </Row>
            {selectedFormData.entryDate && <Row className='d-flex justify-content-center align-items-center p-2'>
                <Col md={6}>
                    <strong><Langs str='ENTRY_DATE' /></strong>
                </Col>
                <Col md={6}>
                    <div>{getFormattedDate(selectedFormData.entryDate)}</div>
                </Col>
            </Row>}
            <Row className='d-flex justify-content-center align-items-center p-2'>
                <Col md={6}>
                    <strong><Langs str='STATUS' /></strong>
                </Col>
                <Col md={6}>
                    <div style={{ color: (["Présent", "Actif"].includes(selectedFormData.statut) ? "green" : "red") }}>
                        <strong>{selectedFormData.statut}</strong>
                    </div>
                </Col>
            </Row>
            {selectedFormData.exitDate && <Row className='d-flex justify-content-center align-items-center p-2'>
                <Col md={6}>
                    <strong><Langs str='EXIT_DATE' /></strong>
                </Col>
                <Col md={6} className='text-danger'>
                    <div>{getFormattedDate(selectedFormData.exitDate)}</div>
                </Col>
            </Row>}
        </div>
    }

    // ─── Mobile minimized view using MUI List ───
    function getMobileMinimizedView() {
        const isActive = ["Présent", "Actif"].includes(selectedFormData.statut);

        const infoRows = [
            { label: 'FAMILY_NAME', value: selectedFormData.nom },
            { label: 'NAME', value: selectedFormData.prenom },
            { label: 'POSTE', value: selectedFormData.poste },
        ];

        if (selectedFormData.entryDate) {
            infoRows.push({ label: 'ENTRY_DATE', value: getFormattedDate(selectedFormData.entryDate) });
        }

        infoRows.push({
            label: 'STATUS',
            value: (
                <Chip
                    label={selectedFormData.statut}
                    size="small"
                    sx={{
                        fontWeight: 600,
                        fontSize: '12.5px',
                        px: 0.5,
                        height: 28,
                        borderRadius: '14px',
                        backgroundColor: isActive ? 'rgba(46,125,50,0.12)' : 'rgba(198,40,40,0.10)',
                        color: isActive ? '#2e7d32' : '#c62828',
                        boxShadow: isActive
                            ? '0 2px 8px rgba(46,125,50,0.25)'
                            : '0 2px 8px rgba(198,40,40,0.20)',
                        border: isActive
                            ? '1px solid rgba(46,125,50,0.20)'
                            : '1px solid rgba(198,40,40,0.18)',
                        transition: 'all 250ms cubic-bezier(0.4,0,0.2,1)',
                    }}
                />
            ),
        });

        if (selectedFormData.exitDate) {
            infoRows.push({
                label: 'EXIT_DATE',
                value: (
                    <Typography variant="body2" sx={{ color: '#c62828', fontWeight: 600 }}>
                        {getFormattedDate(selectedFormData.exitDate)}
                    </Typography>
                ),
            });
        }

        return (
            <List disablePadding>
                {infoRows.map((row, idx) => (
                    <React.Fragment key={row.label}>
                        <ListItem
                            sx={{
                                py: 1.5,
                                px: 2,
                                display: 'flex',
                                justifyContent: 'space-between',
                                alignItems: 'center',
                                minHeight: 56,
                            }}
                        >
                            <ListItemText
                                primary={<Langs str={row.label} />}
                                primaryTypographyProps={{
                                    variant: 'body2',
                                    sx: { fontWeight: 600, color: 'text.secondary' },
                                }}
                                sx={{ flex: '0 0 40%' }}
                            />
                            <Box sx={{ flex: '0 0 55%', textAlign: 'right' }}>
                                {typeof row.value === 'string' ? (
                                    <Typography variant="body1" sx={{ fontWeight: 500 }}>
                                        {row.value}
                                    </Typography>
                                ) : (
                                    row.value
                                )}
                            </Box>
                        </ListItem>
                        {idx < infoRows.length - 1 && <Divider />}
                    </React.Fragment>
                ))}
            </List>
        );
    }

    // ─── Mobile maximized view: wraps existing DataTable + financial table in scrollable Box ───
    function getMobileMaximizedView() {
        const mobileTableStyles = {
            width: '100%',
            borderCollapse: 'collapse',
            fontSize: '13px',
        };
        const mobileTh = {
            backgroundColor: '#f5f5f5',
            padding: '8px 10px',
            textAlign: 'left',
            fontWeight: 600,
            fontSize: '12px',
            whiteSpace: 'nowrap',
            border: '1px solid #e0e0e0',
        };
        const mobileTd = {
            padding: '6px 10px',
            fontSize: '13px',
            border: '1px solid #e0e0e0',
        };
        const sectionHeader = {
            backgroundColor: 'rgba(255,144,21,0.14)',
            color: '#e07e0d',
            fontWeight: 700,
            padding: '10px 12px',
            fontSize: '12.5px',
            textAlign: 'left',
            border: '1px solid #e0e0e0',
            borderLeft: '3px solid #FF9015',
            letterSpacing: '0.3px',
        };
        const separatorRow = {
            height: '8px',
            backgroundColor: 'transparent',
            border: 'none',
        };
        const primeRowEven = {
            ...mobileTh,
            backgroundColor: '#f0f4ff',
        };
        const primeRowOdd = {
            ...mobileTd,
            backgroundColor: '#f0f4ff',
        };
        const primeTdEven = {
            ...mobileTd,
            backgroundColor: '#f0f4ff',
        };

        return (
            <Box sx={{ pb: 10 }}>
                {/* Planning DataTable */}
                <Typography variant="subtitle2" sx={{ px: 1, pt: 1, pb: 0.5, fontWeight: 700, color: '#555', fontSize: '13px', textTransform: 'uppercase', letterSpacing: '0.5px' }}>
                    Planning du mois
                </Typography>
                <Box sx={{ overflowX: 'auto', WebkitOverflowScrolling: 'touch', mb: 3, mx: 0 }}>
                    <DataTable id="collab-table-1" value={collabData} size={"small"} showGridlines rowClassName={rowClass}>
                        <Column header="Jour" field="day" style={{ minWidth: '5rem', overflow: 'hidden' }}></Column>
                        <Column header="Date" field="date" style={{ minWidth: '5rem', overflow: 'hidden' }}></Column>
                        <Column header="Vacation" field="vacation" style={{ minWidth: '5rem', overflow: 'hidden' }}></Column>
                        <Column header="Intervention" field="intervention" style={{ minWidth: '6rem', overflow: 'hidden' }}></Column>
                        <Column header="Commentaires" field="description" style={{ minWidth: '9rem', maxWidth: '12rem', overflow: 'hidden' }}></Column>
                        <Column header="Astreinte" body={astreinteCellStyle} style={{ minWidth: '5rem', backgroundColor: "var(--orange-100)", padding: "0 0", overflow: 'hidden' }}></Column>
                    </DataTable>
                </Box>

                {/* Financial summary table */}
                <Typography variant="subtitle2" sx={{ px: 1, pb: 0.5, fontWeight: 700, color: '#555', fontSize: '13px', textTransform: 'uppercase', letterSpacing: '0.5px' }}>
                    Récapitulatif financier
                </Typography>
                <Box sx={{ overflowX: 'auto', WebkitOverflowScrolling: 'touch', borderRadius: '8px', border: '1px solid #e0e0e0', mx: 0 }}>
                    <table id="collab-table-2" style={mobileTableStyles}>
                        <thead>
                            <tr>
                                <th style={mobileTh}><Langs str='NAME' /></th>
                                <td style={mobileTd} colSpan="3">{selectedFormData.label}</td>
                            </tr>
                            <tr>
                                <th style={mobileTh}><Langs str='COMPANY' /></th>
                                <td style={mobileTd} colSpan="3">{selectedFormData.company}</td>
                            </tr>
                            <tr>
                                <th style={mobileTh}><Langs str='MATRICULE' /></th>
                                <td style={mobileTd} colSpan="3">{selectedFormData.matricule}</td>
                            </tr>
                            {selectedFormData.ancienneteeDate ? (
                                <tr>
                                    <th style={mobileTh}><Langs str='DATE_ANCIENNETE' /></th>
                                    <td style={mobileTd} colSpan="3">{getFormattedDate(selectedFormData.ancienneteeDate)}</td>
                                </tr>
                            ) : (
                                selectedFormData.entryDate && (
                                    <tr>
                                        <th style={mobileTh}><Langs str='ENTRY_DATE' /></th>
                                        <td style={mobileTd} colSpan="3">{getFormattedDate(selectedFormData.entryDate)}</td>
                                    </tr>
                                )
                            )}
                            {selectedFormData.exitDate && (
                                <tr>
                                    <th style={mobileTh}><Langs str='EXIT_DATE' /></th>
                                    <td style={{ ...mobileTd, color: '#d32f2f' }} colSpan="3">{getFormattedDate(selectedFormData.exitDate)}</td>
                                </tr>
                            )}
                            <tr>
                                <th style={mobileTh}><Langs str='CLIENT' /></th>
                                <td style={mobileTd} colSpan="3">{collabReport.clientTeamName}</td>
                            </tr>
                            <tr style={separatorRow}><td colSpan="4" style={{ border: 'none' }} /></tr>
                        </thead>
                        <tbody>
                            <tr>
                                <th style={sectionHeader} colSpan={4}><Langs str='RECAPITULATIF DES HEURES' /></th>
                            </tr>
                            <tr>
                                <th style={mobileTh}><Langs str='Normales' /></th>
                                <td style={mobileTd}>{collabReport && collabReport.normal}</td>
                                <td style={mobileTd}>{collabReport && collabReport.normal}</td>
                                <th style={{ ...mobileTh, textAlign: 'center', verticalAlign: 'middle' }} rowSpan="7" colSpan={1}>{collabReport && collabReport.total}</th>
                            </tr>
                            <tr>
                                <th style={mobileTh}><Langs str='Nuit' /></th>
                                <td style={mobileTd}>{collabReport && collabReport.nuit}</td>
                                <td style={mobileTd}>{collabReport && collabReport.nuit_}</td>
                            </tr>
                            <tr>
                                <th style={mobileTh}><Langs str='Samedi' /></th>
                                <td style={mobileTd}>{collabReport && collabReport.saturday}</td>
                                <td style={mobileTd}>{collabReport && collabReport.saturday_}</td>
                            </tr>
                            <tr>
                                <th style={mobileTh}><Langs str='Dimanche' /></th>
                                <td style={mobileTd}>{collabReport && collabReport.hs100}</td>
                                <td style={mobileTd}>{collabReport && collabReport.hs100_}</td>
                            </tr>
                            <tr>
                                <th style={mobileTh}><Langs str='Supp' /></th>
                                <td style={mobileTd}>{collabReport && collabReport.supp}</td>
                                <td style={mobileTd}>{collabReport && collabReport.supp_}</td>
                            </tr>
                            <tr>
                                <th style={mobileTh}><Langs str='Fériées 100%' /></th>
                                <td style={mobileTd}>{collabReport && collabReport.hs00}</td>
                                <td style={mobileTd}>{collabReport && collabReport.hs00}</td>
                            </tr>
                            <tr>
                                <th style={mobileTh}><Langs str='Fériées 200%' /></th>
                                <td style={mobileTd}>{collabReport && collabReport.hs200}</td>
                                <td style={mobileTd}>{collabReport && collabReport.hs200_}</td>
                            </tr>
                            <tr>
                                <th style={mobileTh}><Langs str='Repos' /></th>
                                <th style={{ ...mobileTh, textAlign: 'center' }} colSpan={3}>{collabReport && collabReport.repos}</th>
                            </tr>
                            <tr style={separatorRow}><td colSpan="4" style={{ border: 'none' }} /></tr>
                            <tr>
                                <th style={sectionHeader} colSpan={4}>Primes</th>
                            </tr>
                            <tr>
                                <th style={primeRowEven}><Langs str='Prime Astreinte' /></th>
                                <td style={{ ...primeTdEven, maxWidth: '80px' }} colSpan="3">
                                    <InputWithSubmit value={collabReport.primes['ASTREINTE'] || 0} type='Number' id='ASTREINTE' min={0} onSubmit={handlePrimeSubmit} disabled={!isOwner(userRoleId)} />
                                </td>
                            </tr>
                            <tr>
                                <th style={primeRowEven}><Langs str='Prime Week-end' /></th>
                                <td style={{ ...primeTdEven, maxWidth: '80px' }} colSpan="3">
                                    <InputWithSubmit value={collabReport.primes['WEEKEND'] || 0} type='Number' id='WEEKEND' min={0} onSubmit={handlePrimeSubmit} disabled={!isOwner(userRoleId)} />
                                </td>
                            </tr>
                            <tr>
                                <th style={primeRowEven}><Langs str='Prime Mission' /></th>
                                <td style={{ ...primeTdEven, maxWidth: '80px' }} colSpan="3">
                                    <InputWithSubmit value={collabReport.primes['MISSION'] || 0} type='Number' id='MISSION' min={0} onSubmit={handlePrimeSubmit} disabled={!isOwner(userRoleId)} />
                                </td>
                            </tr>
                            <tr>
                                <th style={primeRowEven}><Langs str='Prime Qualité' /></th>
                                <td style={{ ...primeTdEven, maxWidth: '80px' }} colSpan="3">
                                    <InputWithSubmit value={collabReport.primes['QUALITE'] || 0} type='Number' min={0} id='QUALITE' onSubmit={handlePrimeSubmit} disabled={!isOwner(userRoleId)} />
                                </td>
                            </tr>
                            <tr>
                                <th style={primeRowEven}><Langs str='Prime Objectif' /></th>
                                <td style={{ ...primeTdEven, maxWidth: '80px' }} colSpan="3">
                                    <InputWithSubmit value={collabReport.primes['OBJECTIF'] || 0} type='Number' min={0} id='OBJECTIF' onSubmit={handlePrimeSubmit} disabled={!isOwner(userRoleId)} />
                                </td>
                            </tr>
                            <tr>
                                <th style={primeRowEven}><Langs str='Prime Quadri' /></th>
                                <td style={{ ...primeTdEven, maxWidth: '80px' }} colSpan="3">
                                    <InputWithSubmit value={collabReport.primes['QUADRI'] || 0} type='Number' min={0} id='QUADRI' onSubmit={handlePrimeSubmit} disabled={!isOwner(userRoleId)} />
                                </td>
                            </tr>
                            <tr>
                                <th style={primeRowEven}><Langs str='Prime Noel' /></th>
                                <td style={{ ...primeTdEven, maxWidth: '80px' }} colSpan="3">
                                    <InputWithSubmit value={collabReport.primes['NOEL'] || 0} type='Number' min={0} id='NOEL' onSubmit={handlePrimeSubmit} disabled={!isOwner(userRoleId)} />
                                </td>
                            </tr>
                            <tr>
                                <th style={primeRowEven}><Langs str='Frais Téléphonique' /></th>
                                <td style={{ ...primeTdEven, maxWidth: '80px' }} colSpan="3">
                                    <InputWithSubmit value={collabReport.primes['FRAIS_TEL'] || 0} type='Number' id='FRAIS_TEL' min={0} onSubmit={handlePrimeSubmit} disabled={!isOwner(userRoleId)} />
                                </td>
                            </tr>
                            <tr style={separatorRow}><td colSpan="4" style={{ border: 'none' }} /></tr>
                            <tr>
                                <th style={sectionHeader} colSpan={4}><Langs str='PAIE AVANT ABSENCES' /></th>
                            </tr>
                            <tr>
                                <th style={mobileTh}><Langs str='Salaire Base' /></th>
                                <td style={mobileTd}>0</td>
                                <th style={mobileTh}><Langs str='Taux horaire' /></th>
                                <td style={mobileTd}>0</td>
                            </tr>
                            <tr>
                                <th style={mobileTh}><Langs str='Salaire Brut' /></th>
                                <td style={mobileTd} colSpan="3">0</td>
                            </tr>
                            <tr style={separatorRow}><td colSpan="4" style={{ border: 'none' }} /></tr>
                            <tr>
                                <th style={sectionHeader} colSpan={4}>Absences</th>
                            </tr>
                            <tr>
                                <th style={mobileTh}><Langs str='Maladie' /></th>
                                <td style={mobileTd} colSpan="3">{collabReport && collabReport.maladie}</td>
                            </tr>
                            <tr>
                                <th style={mobileTh}><Langs str='Congés Payés' /></th>
                                <td style={mobileTd} colSpan="3">{collabReport && collabReport.cp}</td>
                            </tr>
                            <tr>
                                <th style={mobileTh}><Langs str='Maternity' /></th>
                                <td style={mobileTd}>{collabReport && collabReport.maternity}</td>
                                <td style={mobileTd}>0</td>
                                <td style={mobileTd}>0</td>
                            </tr>
                            <tr>
                                <th style={mobileTh}><Langs str='Absence' /></th>
                                <td style={mobileTd}>{collabReport && collabReport.ai}</td>
                                <td style={mobileTd}>0</td>
                                <td style={mobileTd}>0</td>
                            </tr>
                            <tr>
                                <th style={mobileTh}><Langs str='Congés ss Solde' /></th>
                                <td style={mobileTd}>{collabReport && collabReport.css}</td>
                                <td style={mobileTd}>0</td>
                                <td style={mobileTd}>0</td>
                            </tr>
                            <tr>
                                <th style={mobileTh}><Langs str='Heures de retard' /></th>
                                <td style={mobileTd}>{collabReport && collabReport.missing}</td>
                                <td style={mobileTd}>0</td>
                                <td style={mobileTd}>0</td>
                            </tr>
                            <tr style={separatorRow}><td colSpan="4" style={{ border: 'none' }} /></tr>
                            <tr>
                                <th style={sectionHeader} colSpan={4}><Langs str='CALCUL PAIE' /></th>
                            </tr>
                            <tr>
                                <th style={mobileTh}><Langs str='Salaire Base' /></th>
                                <td style={mobileTd}>0</td>
                                <th style={mobileTh}><Langs str='Taux horaire' /></th>
                                <td style={mobileTd}>0</td>
                            </tr>
                            <tr>
                                <th style={mobileTh}><Langs str='Salaire Brut' /></th>
                                <td style={mobileTd} colSpan="3">0</td>
                            </tr>
                            <tr style={separatorRow}><td colSpan="4" style={{ border: 'none' }} /></tr>
                            <tr>
                                <th style={mobileTh}><Langs str='Nb Jours travaillés' /></th>
                                <td style={{ ...mobileTd, fontWeight: 600 }} colSpan={3}>{collabReport && collabReport.presence}</td>
                            </tr>
                            <tr style={separatorRow}><td colSpan="4" style={{ border: 'none' }} /></tr>
                            <tr>
                                <th style={sectionHeader} colSpan={4}><Langs str='FRAIS' /></th>
                            </tr>
                            <tr>
                                <th style={mobileTh}><Langs str='Frais de Repas' /></th>
                                <td style={mobileTd} colSpan={3}>{collabReport && collabReport.repas}</td>
                            </tr>
                            <tr>
                                <th style={mobileTh}><Langs str='Frais Transport' /></th>
                                <td style={mobileTd} colSpan={3}>{collabReport && collabReport.transport}</td>
                            </tr>
                            <tr>
                                <th style={mobileTh}><Langs str='Forfait Déplacement' /></th>
                                <td style={mobileTd} colSpan={3}>{collabReport && collabReport.deplacement}</td>
                            </tr>
                            <tr>
                                <th style={mobileTh}><Langs str='Télétravail' /></th>
                                <td style={mobileTd} colSpan={3}>{collabReport && collabReport.telework}</td>
                            </tr>
                        </tbody>
                    </table>
                </Box>
            </Box>
        );
    }

    // ─── Mobile PDF footer (sticky bottom) ───
    function getMobilePdfFooter() {
        if (!maximized || !collabReport) return null;
        return (
            <Box
                sx={{
                    position: 'sticky',
                    bottom: 0,
                    left: 0,
                    right: 0,
                    backgroundColor: 'rgba(255,255,255,0.85)',
                    backdropFilter: 'blur(12px)',
                    WebkitBackdropFilter: 'blur(12px)',
                    boxShadow: '0 -4px 20px rgba(255,144,21,0.10), 0 -1px 6px rgba(0,0,0,0.05)',
                    borderTop: '1px solid rgba(255,144,21,0.12)',
                    px: 2,
                    py: 1.5,
                    display: 'flex',
                    flexDirection: 'column',
                    gap: 1,
                    zIndex: 1,
                }}
            >
                <MuiButton
                    variant="contained"
                    startIcon={<PictureAsPdfIcon />}
                    onClick={() => handleImpressCra("CRA")}
                    fullWidth
                    sx={{
                        background: 'linear-gradient(135deg, #FF9015 0%, #e07e0d 100%)',
                        boxShadow: '0 4px 16px rgba(255,144,21,0.40)',
                        '&:hover': {
                            background: 'linear-gradient(135deg, #e07e0d 0%, #cc6e00 100%)',
                            boxShadow: '0 6px 24px rgba(255,144,21,0.50)',
                            transform: 'scale(1.02)',
                        },
                        '&:active': { transform: 'scale(0.98)' },
                        borderRadius: '14px',
                        textTransform: 'none',
                        fontWeight: 600,
                        minHeight: 50,
                        fontSize: '15px',
                        letterSpacing: '0.3px',
                        transition: 'all 250ms cubic-bezier(0.4,0,0.2,1)',
                    }}
                >
                    <Langs str="Générer CRA PDF" />
                </MuiButton>
                {isOwner(userRoleId) && (
                    <MuiButton
                        variant="outlined"
                        startIcon={<PictureAsPdfIcon />}
                        onClick={() => handleImpressCra()}
                        fullWidth
                        sx={{
                            borderColor: 'rgba(255,144,21,0.5)',
                            borderWidth: '1.5px',
                            color: '#FF9015',
                            backgroundColor: 'rgba(255,144,21,0.04)',
                            '&:hover': {
                                borderColor: '#FF9015',
                                backgroundColor: 'rgba(255,144,21,0.10)',
                                boxShadow: '0 0 16px rgba(255,144,21,0.20)',
                                transform: 'scale(1.02)',
                            },
                            '&:active': { transform: 'scale(0.98)' },
                            borderRadius: '14px',
                            textTransform: 'none',
                            fontWeight: 600,
                            minHeight: 50,
                            fontSize: '15px',
                            letterSpacing: '0.3px',
                            transition: 'all 250ms cubic-bezier(0.4,0,0.2,1)',
                        }}
                    >
                        <Langs str="Générer Compta PDF" />
                    </MuiButton>
                )}
            </Box>
        );
    }

    // ─── Mobile full-screen Dialog ───
    function renderMobileDialog() {
        const title = maximized
            ? moment(selectedDate, "x").format("MMMM YYYY")
            : selectedFormData.label;

        return (
            <Dialog
                open={!!props.show}
                onClose={onHide}
                fullScreen
                TransitionComponent={SlideUpTransition}
                sx={{
                    zIndex: 1400,
                    '& .MuiDialog-paper': {
                        display: 'flex',
                        flexDirection: 'column',
                    },
                }}
            >
                {/* Sticky AppBar */}
                <AppBar
                    sx={{
                        position: 'sticky',
                        top: 0,
                        background: 'linear-gradient(135deg, #FF9015 0%, #e07e0d 100%)',
                        zIndex: 2,
                        boxShadow: '0 2px 12px rgba(255,144,21,0.35)',
                    }}
                    elevation={0}
                >
                    <Toolbar sx={{ minHeight: 56 }}>
                        <IconButton
                            edge="start"
                            color="inherit"
                            onClick={onHide}
                            aria-label="Fermer"
                            sx={{ mr: 1 }}
                        >
                            <CloseIcon />
                        </IconButton>
                        <Typography
                            variant="h6"
                            sx={{
                                flex: 1,
                                fontSize: '16px',
                                fontWeight: 600,
                                whiteSpace: 'nowrap',
                                overflow: 'hidden',
                                textOverflow: 'ellipsis',
                            }}
                        >
                            {title}
                        </Typography>
                        {collabReport != null && (
                            <IconButton
                                color="inherit"
                                onClick={() => setMaximized(prev => !prev)}
                                aria-label={maximized ? "Réduire" : "Agrandir"}
                            >
                                {maximized ? <FullscreenExitIcon /> : <FullscreenIcon />}
                            </IconButton>
                        )}
                    </Toolbar>
                </AppBar>

                {/* Scrollable content */}
                <DialogContent
                    sx={{
                        flex: 1,
                        p: 0,
                        overflowY: 'auto',
                        WebkitOverflowScrolling: 'touch',
                        '& input': { fontSize: '16px' },
                    }}
                >
                    <Box sx={{ px: maximized ? 2 : 0, py: maximized ? 2 : 0 }}>
                        {maximized ? getMobileMaximizedView() : getMobileMinimizedView()}
                    </Box>
                </DialogContent>

                {/* Sticky PDF buttons footer */}
                {getMobilePdfFooter()}
            </Dialog>
        );
    }

    // ─── Desktop PrimeReact Dialog (unchanged) ───
    function renderDesktopDialog() {
        let dialogWidth;
        if (isMobile === 2) {
            dialogWidth = '80%';
        } else if (isMobile === 3){
            dialogWidth = '60vw';
        } else {
            dialogWidth = '40vw';
        }

        return (
            <PrimeDialog
                onHide={() => onHide()}
                header={maximized ? moment(selectedDate, "x").format("MMMM YYYY") : selectedFormData.label}
                visible={props.show}
                maximizable={collabReport != null}
                maximized={maximized}
                onMaximize={handleMaximize}
                style={{ width: dialogWidth }}
            >
                {maximized ? getMaximizedView() : getMinimizedView()}
            </PrimeDialog>
        );
    }

    // ─── Render: mobile vs desktop ───
    if (isMobile === 2) {
        return renderMobileDialog();
    }

    return renderDesktopDialog();
}
